
import Vue, {VueConstructor} from 'vue'
import QueryMixin from '~/mixins/query.mixin'
import ResponsiveMixin from '~/mixins/responsive.mixin'
import {ChefInterface} from "~/store/chef";

export default (Vue as VueConstructor<Vue & InstanceType<typeof ResponsiveMixin> & InstanceType<typeof QueryMixin>>).extend({
  name: 'ProfileReviewsWrite',
  mixins: [ResponsiveMixin, QueryMixin],
  head() {
    return {
      bodyAttrs: {
        class: 'bg-white text-offBlack'
      },
      title: this.$data.seoTitle,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$data.seoDescriptionMeta,
        }
      ],
    }
  },
  data(): {
    mobileMenuOpen: boolean,
    showChefScorePopup: boolean,
    seoTitle: string,
    seoDescriptionMeta: string,
    chef: ChefInterface | null,
  } {
    return {
      mobileMenuOpen: false,
      showChefScorePopup: false,
      seoTitle: '',
      seoDescriptionMeta: '',
      chef: null,
    }
  },
  computed: {
    chefIdOrSlug(): string {
      return this.$route.params.id
    },
    chefId(): string {
      return (this.chef?.id ?? 0).toString(10)
    },
  },
  async fetch() {
    // @ts-ignore
    this.chef = await this.$axios.$get<{ data: ChefInterface }>(`/v1/chef/${this.chefIdOrSlug}`).then(data => data.data).catch(() => {
      this.$nuxt.context.redirect('/');
      return;
    });

    if (!this.chef) {
      return;
    }

    this.seoTitle = `${this.chef.display_name} reviews`;
    this.seoDescriptionMeta = `Bekijk hier de reviews van ${this.chef.display_name}`;
  }
})
